import { makeStyles } from "tss-react/mui";

interface IParams {
    hasBackground?: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, props) => ({
    labelPriceTotal: {
        display: "flex",
        justifyContent: "space-between",
        padding: theme.spacing(1.5),
        backgroundColor: props.hasBackground ? theme.palette.background.dark : theme.palette.background.paper,
        borderRadius: theme.shape.borderRadius,
    },
    labelPriceTotalContent: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: theme.spacing(0.5),
    },
    labelPriceTotalLeftSection: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(0.5),
    },
    labelPriceTotalLabel: {
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightBold,
    },
    labelPriceTotalSublabel: {
        color: theme.palette.secondary.main,
    },
    labelPriceTotalPrice: {
        color: theme.palette.secondary.main,
        fontWeight: theme.typography.fontWeightBold,
    },
    labelPriceTotalIcon: {
        display: "flex",
        alignItems: "center",
        "& svg": {
            backgroundColor: "transparent",
            color: theme.palette.primary.main,
        },
    },
    priceTotalSkeleton: {
        borderRadius: "16px",
        height: 48,
        width: 100,
    },
}));
